export { MagnetOnboardingPage } from './MagnetOnboardingPage';
